import DesignerTreeHandler from "./../reducers/handlers/DesignerTreeHandler";
const convertJSONToComponents = DesignerTreeHandler.convertJSONToComponents;

export { convertJSONToComponents };
